export default "__VITE_ASSET__CbgS0fsV__"